import baseAPI from '@/api/base';
import { EditEmployeeAttendanceShift, GetEmployeeAttendanceShift, RegisterEmployeeAttendanceShift } from '@/dtos/employee_attendance_shift.dto';
import {
  DELETE_EMPLOYEE_ATTENDANCE_SHIFT_URL,
  EDIT_EMPLOYEE_ATTENDANCE_SHIFT_URL,
  GET_EMPLOYEE_ATTENDANCE_SHIFT_URL,
  REGISTER_EMPLOYEE_ATTENDANCE_SHIFT_URL,
  TOGGLE_EMPLOYEE_ATTENDANCE_SHIFT_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeAttendanceShift {
  static getEmployeeAttendanceShifts = async (getEmployeeAttendanceShift: GetEmployeeAttendanceShift): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_ATTENDANCE_SHIFT_URL, {
      params: getEmployeeAttendanceShift,
    });
    console.log('response', response);
    return response;
  };

  static registerEmployeeAttendanceShift = async (
    registerEmployeeAttendanceShift: RegisterEmployeeAttendanceShift
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_ATTENDANCE_SHIFT_URL, {
      ...registerEmployeeAttendanceShift,
    });
    console.log('response', response);
    return response;
  };

  static editEmployeeAttendanceShift = async (editEmployeeAttendanceShift: EditEmployeeAttendanceShift): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_ATTENDANCE_SHIFT_URL, {
      ...editEmployeeAttendanceShift,
    });
    return response;
  };

  static toggleEmployeeAttendanceShiftIsActive = async (
    editEmployeeAttendanceShift: EditEmployeeAttendanceShift
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_ATTENDANCE_SHIFT_IS_ACTIVE_URL,
      {
        ...editEmployeeAttendanceShift,
      }
    );
    return response;
  };

  static deleteEmployeeAttendanceShift = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_ATTENDANCE_SHIFT_URL}/${userId}`
    );
    return response;
  };
}

export default EmployeeAttendanceShift;
